/** Server manifest for one subject offline pack (OFFLINE_CONTENT_PACKS.md). */
export interface ContentPackManifest {
  packId: string;
  courseId: number;
  subjectId: number;
  subjectName?: string;
  subjectIds?: number[];
  seedIds?: number[];
  contentVersion: string;
  packSchemaVersion: number;
  packSchemaHash: string;
  questionCount: number;
  sha256: string;
}

export const SUPPORTED_CONTENT_PACK_SCHEMA_VERSION = 1;
export const SUPPORTED_CONTENT_PACK_SCHEMA_HASHES = new Set<string>([
  // Must match the backend canonical pack schema descriptor hash.
  '71d7b4eeff275cd8740dd8c63237b3c90f54fdc0acb269cd60a713d5a7bf0a81',
]);

export function isSupportedContentPackSchema(manifest: ContentPackManifest): boolean {
  return manifest.packSchemaVersion === SUPPORTED_CONTENT_PACK_SCHEMA_VERSION
    && SUPPORTED_CONTENT_PACK_SCHEMA_HASHES.has(manifest.packSchemaHash);
}

export interface ContentPackListResponse {
  courseId: number;
  packs: ContentPackManifest[];
}

export interface ContentPackCheckResponse {
  updateAvailable: boolean;
  manifest: ContentPackManifest;
}

export interface ContentKeyResponse {
  key: string;
  expiresAt: string;
  packVersion: string;
  downloadUrl: string;
}

export interface ContentPackQuestion {
  id: number;
  title: string;
  tip: string | null;
  image: string | null;
  answers: {
    option: string;
    label: string;
    value: number;
    isCorrect: boolean;
    isChecked: boolean;
    isDisabled: boolean;
    tip: string | null;
  }[];
}

export interface ContentPackDownloadPayload {
  manifest: ContentPackManifest;
  questionIds: number[];
  questions: ContentPackQuestion[];
}
